import './InputLabel-eb267c58.css';

var classes = {"Label":"prc-components-Label-bE-kK","RequiredText":"prc-components-RequiredText-ztJvt"};

export { classes as default };
